export { default as usePlaceholder } from "./use-placeholder"
export type { PlaceholderProps } from "./use-placeholder"
